const isEmpty = (item) => {
    return Object.keys(item).length === 0;
}

export { isEmpty }
